module.exports = __webpack_public_path__ + "static/media/top-filter-light-icon.316a673f.svg";